import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectUserGroup } from '../../../store/authReducer';
import {
  viewPermissionRefs,
  findPermissionRef,
} from '../../../core/components/UserGroupPermissions';
import MaintenanceTasks from './containers/MaintenanceTasks';
import MaintenanceTaskOld from './containers/MaintenanceTaskOld';

const MaintenanceTasksIndex = () => {
  const userGroup = useSelector(selectUserGroup);

  const hasMaintenancePageNewPermission = useMemo(() => {
    if (!userGroup?.permissions) return false;
    return Boolean(
      findPermissionRef(userGroup.permissions, viewPermissionRefs.maintenance_page_new) ||
        findPermissionRef(userGroup.permissions, viewPermissionRefs.admin)
    );
  }, [userGroup]);

  return hasMaintenancePageNewPermission ? <MaintenanceTasks /> : <MaintenanceTaskOld />;
};

export default MaintenanceTasksIndex;
